module.exports = __webpack_public_path__ + "img/add.92919c0d.svg";